import { TeacherQuestionItem } from './TeacherQuestionItem';

export { TeacherQuestionItem };
